import { ReviewThreadStatus } from "@/api/cle-api";
import { AccordionFilterItem } from "@/components/accordion/Accordion";
import InputCheckbox from "@/components/formcontrols/InputCheckbox";

interface ReviewThreadStatusFilterProps {
  statuses: ReviewThreadStatus[];
  onStatusToggle: (status: ReviewThreadStatus, checked: boolean) => void;
}

const statusOptions: Array<{ value: ReviewThreadStatus; label: string }> = [
  { value: ReviewThreadStatus.OPEN, label: "Åbne" },
  { value: ReviewThreadStatus.RESOLVED, label: "Løst" },
];

export default function ReviewThreadStatusFilter({
  statuses,
  onStatusToggle,
}: ReviewThreadStatusFilterProps) {
  return (
    <AccordionFilterItem
      title="Status"
      value="review-thread-status"
      isActive={statuses.length > 0}
    >
      <div className="d-flex flex-column gap-2">
        {statusOptions.map((option) => (
          <InputCheckbox
            key={option.value}
            id={`review-thread-status-${option.value}`}
            label={option.label}
            checked={statuses.includes(option.value)}
            onChange={(event) =>
              onStatusToggle(option.value, event.target.checked)
            }
          />
        ))}
      </div>
    </AccordionFilterItem>
  );
}
